import { marked } from 'marked';
import { POST_REQUEST } from './httpClient';

class MarkdownCore {

    constructor({ invokeWS } = {}) {
        this.invokeWS = invokeWS;
        marked.use({
            breaks: true,
            sanitize: false,
            gfm: true
        });
    }

    appendTo = (obj) => {
        if (typeof obj === "object" && obj !== null) {
            obj.markdown = this.markdown;
            obj.markdownStream = this.markdownStream;
            obj.fetchStream = this.fetchStream;
        }
    }

    markdown = text => {
        let tabuid = "2cb3acff108d4896ae95ba2077b74652";
        let coduid = "33dde4ebec8b437eaa1d80525f07292e";
        let docuid = "b968de5ba385432fb0e9bcd7a289f467";
        let spauid = "9351ddfe6caa44be8e725e2907232755";
        let manipulate = text.includes("\t") || text.includes("```sql");
        if (manipulate) {
            text = text.replaceAll("\t", tabuid)
                .replaceAll("```sql", coduid)
                .replaceAll("```", docuid)
                .replaceAll("\n   ", spauid);
        }
        text = marked.parse(text);
        if (manipulate) {
            text = text.replaceAll(tabuid, "&nbsp;&nbsp;&nbsp;&nbsp;")
                .replaceAll(coduid, "<code>")
                .replaceAll(docuid, "</code>")
                .replaceAll(spauid, "\n&nbsp;&nbsp;&nbsp;");
        }
        return text;
    }

    scroll = scrollContainer => {
        if (scrollContainer) {
            scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        }
    }

    markdownStream = (contentElement, scrollContainer, rednerComplete = () => {}) => {
        let chunks = "";
        let content = "";
        let at = 0;
        let done = false;
        const pulse = '<span class="pulse"><span>';
        const self = this;
        contentElement.innerHTML = pulse;
        this.scroll(scrollContainer);

        const nextValidChar = (s, from) => {
            var i = from;
            while (i < s.length && i != -1) {
                var c = s[i];
                if (c == '<') {
                    i = s.indexOf('>', i) + 1;
                } else if (s[i] == '&') {
                    i = s.indexOf(';', i) + 1;
                } else if (c == '\n' || c == ' ' || c == '\r') {
                    ++i;
                } else {
                    return i;
                }
            }
            return -1;
        };

        const more = () => {
            const isScrolledToBottom = scrollContainer && scrollContainer.scrollHeight - scrollContainer.clientHeight <= scrollContainer.scrollTop + 1;
            // Reveal proportionally to the unrendered backlog instead of one char per tick.
            // The whole response is already parsed into `content` as soon as it arrives over the
            // network; a fixed 1-char/5ms reveal caps output at ~200 chars/sec, letting long or
            // bursty responses fall many seconds behind data that's already here (text appears to
            // freeze mid-word). Draining a fraction of the backlog each tick keeps the typewriter
            // feel for a trickle (small backlog -> step 1) while catching up fast on bursts.
            const step = Math.max(1, Math.floor((content.length - at) / 60));
            let writeTo = at;
            let revealed = -1;
            for (let n = 0; n < step; n++) {
                const next = nextValidChar(content, writeTo);
                if (next == -1) break;
                revealed = next;
                writeTo = next + 1;
            }
            if (revealed != -1) {
                contentElement.innerHTML = content.substring(0, revealed) + pulse;
                at = writeTo;
                if (isScrolledToBottom) {
                    self.scroll(scrollContainer);
                }
            } else if (done) {
                contentElement.innerHTML = content;
                if (isScrolledToBottom) {
                    self.scroll(scrollContainer);
                }
                rednerComplete();
                clearInterval(intervalId);
            }
        };

        let intervalId = setInterval(more, 5);

        const addChunk = (chunk) => {
            if (chunk != null) {
                chunks += chunk;
                content = this.markdown(chunks);
            } else {
                done = true;
                at = content.length;   // stop typing, let `more()` paint it all next tick
            }
        };
        return addChunk;
    }

    fetchStream = async (endpointName, params = {}, callback, verb = POST_REQUEST, version, servlet) => {
        try {
            params.stream = true;
            const response = await this.invokeWS(endpointName, params, verb, version, true, servlet);
            if (response.isError) {
                throw new Error(response.name);
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            // Deliver each chunk as soon as it is decoded. The previous loop read the NEXT chunk
            // before invoking the callback for the current one, so every chunk was held back until
            // the following read returned — when the server paused mid-response, the already-decoded
            // text (e.g. a half-finished line) sat undelivered until more bytes arrived, making the
            // UI appear to freeze mid-word.
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                callback(decoder.decode(value, { stream: true }));
            }
            callback();
        } catch (error) {
            callback(error);
            callback();
        }
    }
}

export function createMarkdown({ invokeWS } = {}) {
    return new MarkdownCore({ invokeWS });
}
